/** @type {import('zudoku').ZudokuConfig} */
const config = {
  basePath: "/apidocs",
  metadata: {
    favicon: "/favicon.svg",
  },
  site: {
    logo: {
      src: { light: "/billit-light.svg", dark: "/billit-dark.svg" },
      alt: "Billit API",
      width: "90px",
    },
  },
  head: [
    {
      tag: "link",
      attrs: {
        rel: "apple-touch-icon",
        href: "/apple-touch-icon.png",
      },
    },
  ],
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          collapsed: false,
          items: [
            {
              type: "link",
              icon: "sparkle",
              label: "Introduction",
              to: "/introduction"
            },
            {
              type: "link",
              icon: "sparkle",
              label: "Tooling",
              to: "/tooling",
            },
            {
              type: "link",
              icon: "folder-cog",
              label: "API Reference",
              to: "/api",
            },
          ],
        },
        {
          type: "category",
          label: "Useful Links",
          collapsible: false,
          icon: "link",
          items: [
            {
              type: "link",
              icon: "sparkle",
              label: "Billit",
              to: "https://billit.io",
            },
            {
              type: "link",
              icon: "atom",
              label: "Sandbox APP",
              to: "https://app.sandbox-billit.xyz",
            },
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  redirects: [{ from: "/", to: "/introduction" }],
  apis: [
    {
      type: "file",
      input: "./apis/billit.yaml",
      path: "/api",
    },
  ],
};

export default config;
